var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{staticClass:"yogo-rounded-full",attrs:{"src":_vm.Imgix(_vm.image.filename || _vm.image, _vm.options)}}):_c('avatar')}
var staticRenderFns = []

export { render, staticRenderFns }